import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col span-12" }


import Tab from '@shell/components/Tabbed/Tab.vue';
import DetailText from '@shell/components/DetailText.vue';

export interface Props {
  knownHosts: string;
  weight?: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    knownHosts: {},
    weight: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tab, {
    name: "known_hosts",
    "label-key": "secret.ssh.knownHosts",
    weight: __props.weight
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DetailText, {
            value: __props.knownHosts,
            "label-key": "secret.ssh.knownHosts",
            conceal: false
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["weight"]))
}
}

})